import {qs, qsa} from '../utils/lib'
const LinkBlanks = () => {
    const news_links = qsa('.news_page_text a', document)
    news_links.forEach(a => {
        a.setAttribute("target","_blank")
        a.setAttribute("rel","noopener")
    })
}   
export default LinkBlanks